module.exports = __webpack_public_path__ + "img/arthritissociety.6d64d6b2.png";